import { AxiosResponse } from "axios";
import axiosClient from "../common/axios/axiosConfig";
import { ErrorToast } from "../common/toast/toast";
import { sendMessageToParentWindow } from "../utils/sendMessageToParentWindow";

interface responseDTO {
  count: number;
}

const getOfflineMessages = (codu: number): Promise<number> => {

  if (localStorage.getItem(`${codu}.offline-messages`)) {
    const cachedData = localStorage.getItem(`${codu}.offline-messages`);
    if (cachedData) {
      const cachedResponse: responseDTO = JSON.parse(cachedData);
      sendMessageToParentWindow("change_title", {
        messageCount: cachedResponse.count,
      });
      return Promise.resolve(cachedResponse.count);
    }
  }

  return axiosClient
    .get("offline-messages", {
      params: { receiver: codu },
    })
    .then((response: AxiosResponse<responseDTO>) => {
      if (response.status === 200) {
        const messageCount = response.data.count;

        sendMessageToParentWindow("change_title", {
          messageCount,
        });

        localStorage.setItem(
          `${codu}.offline-messages`,
          JSON.stringify(response.data)
        );

        return messageCount;
      }
      return 0;
    })
    .catch(() => {
      ErrorToast.fire({
        text: "Erro ao buscar mensagens não lidas",
      });
      return 0;
    });
};

export default getOfflineMessages;
